// extracted by mini-css-extract-plugin
export default {"toggle":"ViewToggle_toggle__a2ILl","option":"ViewToggle_option__ppCxx","active":"ViewToggle_active__YMuZE"};